export default "__VITE_ASSET__gfjJZbQ5__"